// Import gql helper and craft a GraphQL query
import { API, graphqlOperation } from "aws-amplify";

const FlightsQuery = (airline = "440") => {
  return /* GraphQL */ `
query MyQuery {
  listFlights(filter: {
    airlineID: {eq: "${airline}"}
  }) {
    items {
      airlineID
      id
      location
      number
    }
  }
}
`;
};

const CodesQuery = /* GraphQL */ `
  query CodesList {
    listSecondarys {
      items {
        id
        number
        text
      }
    }
  }
`;
const AirlinesQuery = () => {
  return `
query AirlinesList {
  listAirlines {
    items {
      id
      name
      abbreviation
    }
  }
}
`;
};

export const getCodes = () => API.graphql(graphqlOperation(CodesQuery));
export const getAirlines = () => API.graphql(graphqlOperation(AirlinesQuery()));
export const getFlightsByAirline = (airline) =>
  API.graphql(graphqlOperation(FlightsQuery(airline)));
